module.exports = __webpack_public_path__ + "media/images/soar/home_page_figure2-f738d8b4578f9c525a1b9b735fac08fc.png";